module.exports = __webpack_public_path__ + "img/calender-gray.208844c5.svg";